import { render } from "./ManagerPortfolio.vue?vue&type=template&id=0908e274&scoped=true"
const script = {}

import "./ManagerPortfolio.vue?vue&type=style&index=0&id=0908e274&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0908e274"]])

export default __exports__